var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',[_c('h1',{staticClass:"text-3xl font-normal"},[_vm._v(_vm._s(_vm.page.post_title))]),_vm._v(" "),_c('div',{staticClass:"max-w-prose"},[_c('div',{staticClass:"rendered",domProps:{"innerHTML":_vm._s(_vm.page.content.rendered)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fbd484","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPage.vue
// module id = MUjn
// module chunks = 1